import React from 'react';
import { Flex, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { Copy, SvgX } from '@grubhubprod/gh-cookbook-react';

interface ClearButtonProps {
  onClick: () => void;
}

/**
 * ClearButton component for SelectSearch
 * Displays a circular button with an X icon used to clear selections
 */
export const ClearButton: React.FC<ClearButtonProps> = ({ onClick }) => {
  return (
    <Stack
      width="16px"
      height="16px"
      borderRadius="50%"
      x="x-sm"
      backgroundColor="secondaryText"
      onClick={onClick}
    >
      <Copy variant="body" color="globals.white">
        <Flex>
          <SvgX aria-label="clear" size="16px" />
        </Flex>
      </Copy>
    </Stack>
  );
};
